import { render } from "./sign.vue?vue&type=template&id=f433016e&ts=true"
import script from "./sign.vue?vue&type=script&lang=ts"
export * from "./sign.vue?vue&type=script&lang=ts"

import exportComponent from "/home/asan/haisha/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__